<template>
  <Header :style="{position: 'absolute', top:0, width: '100%',minWidth: '1024px'}">
    <!-- logo -->
    <div :class="[!isCollapsed?'logo-large-icon':'logo-small-icon']">
      <img v-show="!isCollapsed" key="max-logo" :src="maxLogo" />
      <img v-show="isCollapsed" key="min-logo" :src="minLogo" />
    </div>
    <!-- navbar -->
    <div :class="[!isCollapsed?'navbar':'navbar-toggle']">
      <span @click="collapsedSider">
        <Icon class="toggle-tap" type="md-menu" size="18" />
      </span>
      <router-link to="/home" tag="span" :class="routerParentMenu=='home:-'?'active':''">{{ $t('WorkBench') }}</router-link>
      <div v-if="headerCtrl">
        <router-link v-for="(menu,index) in menuList" :key="index"
                     v-modulesPermission="[menu.code]"
                     :to="routerLinkTo(menu.code)" tag="span"
                     :class="routerParentMenu==menu.code?'active':''"
        >{{ menu.name }}</router-link>
        <!-- <router-link v-modulesPermission="['project:-']" :to="routerLinkTo('project:-')" tag="span" :class="routerParentMenu=='project:-'?'active':''">{{$t('project')}}</router-link>
                <router-link v-modulesPermission="['mission:-']" :to="routerLinkTo('mission:-')" tag="span" :class="routerParentMenu=='mission:-'?'active':''">{{$t('TaskHall')}}</router-link>
                <router-link v-modulesPermission="['clue:-']" :to="routerLinkTo('clue:-')" tag="span" :class="routerParentMenu=='clue:-'?'active':''">{{$t('Clue')}}</router-link>
                <router-link v-modulesPermission="['case:-']" :to="routerLinkTo('case:-')" tag="span" :class="routerParentMenu=='case:-'?'active':''">{{$t('Case')}}</router-link>
                <router-link v-modulesPermission="['staff:-']" :to="routerLinkTo('staff:-')" tag="span" :class="routerParentMenu=='staff:-'?'active':''">{{$t('MemberManage')}}</router-link>
                <router-link v-modulesPermission="['system:-']" :to="routerLinkTo('system:-')" tag="span" :class="routerParentMenu=='system:-'?'active':''">{{$t('SystemSettings')}}</router-link> -->
      </div>
    </div>
    <!-- 通知、中英文、个人中心 -->
    <div class="header-right">
      <!-- 通知 -->
      <div v-if="false" class="header-notice clearfix" @click="hideOrShow('notice')">
        <Badge :count="100" :offset="[13,24]" type="normal" style="cursor:pointer" :class="noticeCtrl?'active':''">
          <Icon type="ios-notifications-outline" size="24" color="#fff" />
        </Badge>
        <div v-show="noticeCtrl" class="more-router">
          <Card :title="'您有'+noticeArr.length+'条通知'" :padding="0" shadow style="width: 280px;">
            <Scroll :on-reach-bottom="handleReachBottom" :loading-text="loadingText" height="184" :distance-to-edge="10">
              <CellGroup>
                <Cell
                  v-for="(item,index) in noticeArr"
                  :key="index"
                  title="Link"
                  to="/components/button"
                  class="notice-tips"
                >
                  <Icon type="md-contacts" size="18" color="#ed4014" />
                  <h5 :title="item.content">{{ item.content }}</h5>
                </Cell>
              </CellGroup>
            </Scroll>
          </Card>
        </div>
      </div>
      <!-- 中英文 -->
      <span v-if="false">
        <Dropdown trigger="click" @on-click="toggleLang">
          <a href="javascript:void(0)" style="color:#fff;">{{ langStr }}
            <Icon type="ios-arrow-down" />
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="zh-CN">中文</DropdownItem>
            <DropdownItem name="en-US">English</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </span>
      <!-- 个人中心 -->
      <span :class="[infoCtrl?'active':'','head-img-box']" @click="hideOrShow('info')">
        <img :src="avatarSrc" alt="" :title="name">
        <Card v-show="infoCtrl" class="more-router" :padding="0">
          <Col class="info-box">
            <img
              class="head-img"
              :src="avatarSrc"
            >
            <p>{{ name }}</p>
            <!-- <p class="small-p">{{lawOffice}}</p> -->
          </Col>
          <Col class="info-btn-box">
            <router-link to="/personalCenter/information"><Button style="width:45%">{{ $t("MyCenter") }}</Button></router-link>
            <!-- <Button>{{$t("ResetPwd")}}</Button> -->
            <Button style="width:45%" @click="$router.push({path:'/login'}); $store.commit('setHasInfo', false)">{{ $t("Exit") }}</Button>
          </Col>
        </Card>
      </span>
    </div>
  </Header>
</template>
<script>
import store from '@/store/index.js'
export default {
  directives: {
    modulesPermission: {
      inserted: function(el, binding, vnode) {
        const { value } = binding
        const menuJson = store.state.permission && store.state.permission.roles
        const headerBarList = Object.keys(menuJson)
        if (value && value instanceof Array && value.length > 0) {
          const permissionRoles = value
          const hasPermission = headerBarList.some(role => {
            return permissionRoles.includes(role)
          })
          if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el)
          }
        } else {
          throw new Error(`need roles! Like v-permission="['admin','editor']"`)
        }
      }
    }
  },
  components: {

  },
  props: [''],
  data () {
    return {
      name: '',
      isCollapsed: false,
      taskCtrl: false,
      noticeCtrl: false,
      maxLogo: require('./../../assets/images/logo.png'),
      minLogo: require('./../../assets/images/logo-small.png'),
      noticeArr: [
        {
          id: 1,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        },
        {
          id: 2,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        },
        {
          id: 3,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        },
        {
          id: 4,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        },
        {
          id: 5,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        }
      ],
      loadingText: '加载中',
      langStr: '中文',
      infoCtrl: false,
      avatarSrc: require('@/assets/images/portrait.png'),
      headerCtrl: false,
      menuList: []
    }
  },
  computed: {
    routerParentMenu() {
      this.getMenu(this.$route.meta.parentMenu)
      return this.$route.meta.parentMenu
    },
    menuJson() {
      return this.$store.state.permission.roles
    }
  },
  watch: {
    menuJson: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.menuList = store.state.permission && store.state.permission.menu
          this.headerCtrl = true
        }
      }
    }
  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.taskCtrl = false
        this.noticeCtrl = false
        this.infoCtrl = false
      }
    })
    if (Object.keys(this.menuJson).length !== 0) {
      this.menuList = store.state.permission && store.state.permission.menu
      this.headerCtrl = true
    }
    this.getLawyerDetail()
  },
  updated() {

  },
  methods: {
    collapsedSider () {
      this.isCollapsed = !this.isCollapsed
      this.$store.commit('toggleCollapsed', this.isCollapsed)
    },
    // 通知栏移动到底部加载更多
    handleReachBottom() {
      const t = this
      this.c++
      // 必须返回一个promise
      return new Promise(resolve => {
        if (t.c >= 3) {
          t.loadingText = '没有更多数据了'
          resolve()
          return
        }
        setTimeout(() => {
          t.noticeArr.push({
            id: 2,
            content: '测试数据测试数据'
          })
          resolve()
        }, 2000)
      })
    },
    // 切换中英文
    toggleLang(name) {
      this.langStr = name == 'zh-CN' ? '中文' : 'English'
      this.$i18n.locale = name
    },
    // 控制路由
    getMenu(val) {
      const menu = store.state.permission.roles
      this.$store.commit('changeMenu', menu[val])
    },
    hideOrShow(type) {
      if (type === 'taskHall') {
        this.taskCtrl = !this.taskCtrl
        this.noticeCtrl = false
        this.infoCtrl = false
      } else if (type === 'notice') {
        this.noticeCtrl = !this.noticeCtrl
        this.taskCtrl = false
        this.infoCtrl = false
      } else if (type === 'info') {
        this.infoCtrl = !this.infoCtrl
        this.noticeCtrl = false
        this.taskCtrl = false
      }
    },
    // 获取律师详情
    getLawyerDetail() {
      const url = '/base/investigator/my'
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.name = res.data.name
          if (res.data.icon) {
            this.avatarSrc = res.data.icon
          }
        }
      })
    },
    routerLinkTo(val) {
      const menuJson = store.state.permission && store.state.permission.roles
      if (menuJson[val]) {
        if (!menuJson[val][0]['hasChildList']) {
          return menuJson[val][0]['href']
        } else if (menuJson[val][0]['hasChildList']) {
          return menuJson[val][0]['childList'][0]['href']
        }
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="sass" scoped>
 @import './header.scss';
</style>
<style lang="scss">
    .notice-tips .ivu-cell-arrow {
        right: 5px;
    }
    .notice-tips .ivu-cell-title {
        line-height: normal;
    }
    .ivu-cell-title {
        line-height: 24px;
        font-size: 14px;
    }
    .notice-tips:last-child {
        border: none;
    }
    .more-router {
        .ivu-card-head {
            padding: 7px 10px;
        }
        .ivu-scroll-loader:first-child {
            display: none;
        }
        .ivu-spin-text {
            i {
                opacity: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue